import { Modal } from 'react-bootstrap'

interface ReasonRemarkModalProps {
  open: boolean
  onClose: () => void
  html: string | null
  columnTitle: string
}

const ReasonRemarkModal = ({ open, onClose, html, columnTitle }: ReasonRemarkModalProps) => (
  <Modal show={open} onHide={onClose} animation={false} backdrop='static' centered>
    <div className='modal-header py-3'>
      <h2 className='fw-bolder'>{columnTitle}</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-danger'
        style={{ cursor: 'pointer' }}
        onClick={onClose}
      >
        <i className='fa-solid fa-xmark fs-1' />
      </div>
    </div>
    <div className='card-body'>
      <div
        className='my-5 ms-5'
        dangerouslySetInnerHTML={{ __html: html ?? '' }}
      />
    </div>
  </Modal>
)

export default ReasonRemarkModal